import { render, staticRenderFns } from "./big.vue?vue&type=template&id=0a3d6468&scoped=true&"
import script from "./big.vue?vue&type=script&lang=js&"
export * from "./big.vue?vue&type=script&lang=js&"
import style0 from "./big.vue?vue&type=style&index=0&id=0a3d6468&prod&scoped=true&lang=less&"
import style1 from "./big.vue?vue&type=style&index=1&id=0a3d6468&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d6468",
  null
  
)

export default component.exports